export default "__VITE_ASSET__Br7PRbTS__"